var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HMModalContainer',{attrs:{"isStudioPage":true}},[_c('ResetPassword',{on:{"go-to-login":function($event){return _vm.$router.push({ name: 'studio-login' })}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }